<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="success" class="btna"> VALIDAÇÃO </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col> Validação de Inscrição </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Declaro que

              <strong>{{ payload.resposta8 }}/{{ payload.uf }}</strong>
              encontra-se com o termo de parceria válido para o ciclo 2025
              conforme regulamento do Selo Sebrae de Referência em Atendimento.
            </h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          text
          @click="dialog = false"
          style="margin-right: auto"
          >Cancelar</v-btn
        >

        <v-btn color="error" @click="rejeitar"
          >NÃO - Inscrição não validada
        </v-btn>
        <v-btn color="success" @click="aprovar">SIM - Validar Inscrição </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { inscricaoAPI } from "@/apis";
import Swal from "sweetalert2";

export default {
  name: "RejeitarInscricao",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },

    aprovar(item) {
      this.dialog = false;
      Swal.fire({
        title: "Sim - Validar Inscrição",
        html: `Confirma que deseja validar a inscrição de ${
          this.payload.nome
        } ${this.payload.tipo == "Parceiro" ? "do parceiro" : "da sala"} ${
          this.payload.resposta8
            ? this.payload.resposta8
            : "(sem nome cadastrado)"
        } / ${this.payload.uf}? 

     
         `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmo que desejo validar",
        reverseButtons: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          inscricaoAPI
            .aprovarInscricao(this.payload)
            .then(({ data }) => {
              this.$emit("onLoad");
              this.$notification.success("Inscrição validada com sucesso!");

              this.dialog = false;
            })
            .catch((err) => {
              console.log("Error aprovar in inscricao/listar: ", err);
              this.$notification.error("Erro ao validar uma inscrição");
              this.setLoading(false);
            });
        } else {
          this.setLoading(false);
        }
      });
    },
    rejeitar(item) {
      this.dialog = false;
      Swal.fire({
        title: "Não - Inscrição não validada",
        html: `Confirma que <strong>NÃO</strong> deseja validar a inscrição de ${
          this.payload.nome
        } ${this.payload.tipo == "Parceiro" ? "do parceiro" : "da sala"} ${
          this.payload.resposta8
            ? this.payload.resposta8
            : "(sem nome cadastrado)"
        } / ${this.payload.uf}? 
         `,
        input: "text",
        inputLabel: "Justificativa",
        inputPlaceholder: "Justificativa",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmo que NÃO desejo validar",
        reverseButtons: true,
        allowOutsideClick: false,
      }).then((result) => {
        console.log("result", result);
        if (result.isConfirmed) {
          this.payload.justificativa = result.value;
          inscricaoAPI
            .rejeitarInscricao(this.payload)
            .then(({ data }) => {
              this.$notification.success("Inscrição invalidada com sucesso!");

              this.$emit("onLoad");
              this.dialog = false;
            })
            .catch((err) => {
              console.log("Error rejeitar in inscricao/listar: ", err);
              this.$notification.error("Erro ao invalidar uma inscrição");
              this.setLoading(false);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.btna {
  font-size: 8px;
  margin-left: 0 !important;
  text-transform: capitalize;
}
</style>
